import { render, staticRenderFns } from "./EvidenceDrawer.vue?vue&type=template&id=494d5ffa&scoped=true&"
import script from "./EvidenceDrawer.vue?vue&type=script&lang=js&"
export * from "./EvidenceDrawer.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceDrawer.vue?vue&type=style&index=0&id=494d5ffa&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d5ffa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VCardTitle,VNavigationDrawer,VSheet})
